exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout-suggestion-layout-suggestion-container-25qiK{display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);

// Exports
exports.locals = {
	"layout-suggestion-container": "layout-suggestion-layout-suggestion-container-25qiK"
};